/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

const Twitter = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="25"
      fill="none"
      viewBox="0 0 30 25"
      className={className}
    >
      <path
        fill="#fff"
        d="M26.916 6.072c.02.267.02.533.02.8 0 8.128-6.187 17.494-17.494 17.494-3.484 0-6.72-1.01-9.442-2.76.495.056.97.075 1.485.075 2.874 0 5.52-.97 7.633-2.626a6.16 6.16 0 01-5.749-4.264c.381.057.762.095 1.161.095.552 0 1.105-.076 1.619-.21a6.15 6.15 0 01-4.93-6.034v-.076c.818.457 1.77.742 2.778.78a6.144 6.144 0 01-2.74-5.12c0-1.142.304-2.19.837-3.103a17.477 17.477 0 0012.678 6.434 6.945 6.945 0 01-.153-1.409A6.146 6.146 0 0120.768 0a6.13 6.13 0 014.492 1.942c1.39-.267 2.722-.78 3.902-1.485a6.132 6.132 0 01-2.703 3.388A12.326 12.326 0 0030 2.893a13.215 13.215 0 01-3.084 3.18z"
      ></path>
    </svg>
  )
}

Twitter.propTypes = {
  className: PropTypes.string,
}

export default Twitter
